import React from "react";

const ViewPhotoOverlay = () => {
  return (
    <div className="absolute bottom-0 left-0 right-0 top-0 h-full w-full bg-gradient-to-b from-transparent to-black/70"></div>
  );
};

export default ViewPhotoOverlay;
